import React, { Component } from 'react';

import cx from 'classnames';
import { FormModal, Input, Text } from '../../../ui-kit';
import { notify } from '../../Notifications';
import Warning from './Warning';
import '../styles/_delete-confirmation-modal.scss';
















class DeleteConfirmationModal extends Component


{
  constructor() {
    super();

    this.state = {
      deleteConfirmText: ''
    };
  }

  componentDidUpdate(prevProps) {
    const { objectId } = this.props;

    if (prevProps.objectId && !objectId) {this.clearInput();}
  }

  clearInput = () => {
    this.setState({ deleteConfirmText: '' });
  };

  updateConfirmText = ({ target: { value } }) => {
    this.setState({ deleteConfirmText: value });
  };

  handleDelete = async () => {
    const { onDelete, objectId, onComplete, confirmOnly } = this.props;

    if (confirmOnly) {
      onComplete();
      return;
    }

    if (!objectId) {return;}

    if (onDelete) {
      const { data, error } = await onDelete(objectId);

      if (!data || error) {
        notify({ type: 'error', content: 'Something went wrong' });
        return;
      }
    }

    onComplete();
  };

  render() {
    const { hideModal, objectId, title, warnings, children, confirmOnly } = this.props;
    const { deleteConfirmText } = this.state;
    const confirmedDelete = deleteConfirmText.trim().toLowerCase() === 'delete';

    return (
      <div
        className={cx(
          'delete-confirmation-modal',
          { 'delete-confirmation-modal--disabled': !confirmedDelete }
        )}>

        <FormModal
          visible={confirmOnly || Boolean(objectId)}
          title={title}
          saveText="Delete"
          onClose={hideModal}
          saveDisabled={!confirmedDelete}
          onSave={this.handleDelete}
          stayOpenOnSave>

          {children}
          <Text className="delete-confirmation-modal__warning">Warning: This action cannot be undone!</Text>
          {warnings && warnings.length &&
          <div className="delete-confirmation-modal__warnings">
              {warnings.map((text) => <Warning key={text} text={text} />)}
            </div>}

          <Input
            label="To confirm deletion, type 'delete' in to the field (case insensitive)"
            onChange={this.updateConfirmText}
            value={deleteConfirmText} />

        </FormModal>
      </div>);

  }
}

export default DeleteConfirmationModal;